/**
 * Removes any existing video player container from the DOM.
 * This ensures that a new player can be created without conflicts.
 */
export function removeExistingPlayer() {
  const existingPlayerContainer = document.querySelector(
    '.header_trailer-player',
  );
  if (existingPlayerContainer) {
    existingPlayerContainer.remove();
  }
}
